export default {
  getDefaultState: () => {
    return {
      userLogged: {},
      user: {},
      users: [],
      usersSearch: [],
      userNotifications: [],
      filters: {},
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      isCallingUsers: false,
      userBudgets: [],
      userBudgetsCurrentPage: 1,
      userBudgetsLastPage: 1,
      userBudgetsTotalItems: 0,
      isCallingUserBudgets: false,
      getDeletedUsersFlag: false,
      errors: []
    }
  }
}
